import { render } from "./new-modal-right-full-page.html?vue&type=template&id=b259e068&scoped=true&ts=true"
import script from "./new-modal-right-full-page.vue?vue&type=script&lang=ts"
export * from "./new-modal-right-full-page.vue?vue&type=script&lang=ts"

import "./new-modal-right-full-page.scss?vue&type=style&index=0&id=b259e068&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b259e068"]])

export default __exports__